import React, { useEffect } from "react";

import { Alert, Button, Snackbar, Stack } from "@mui/material";

const AlertBox = ({
  status,
  type,
  message,
  control,
  onClose,
  onConfirm,

  mode = "snackbar",
}) => {
  const severity = status === "danger" ? "error" : status;

  /*
   * Overlay alerts need their own
   * timeout because they are not
   * wrapped by MUI Snackbar.
   *
   * Decision/confirmation messages
   * never auto-close.
   */
  useEffect(() => {
    if (mode !== "overlay" || type !== "alert") {
      return undefined;
    }

    const timerId = window.setTimeout(() => {
      onClose?.();
    }, 3000);

    return () => {
      window.clearTimeout(timerId);
    };
  }, [mode, type, onClose]);

  const action =
    type === "decision" ? (
      <Stack direction="row" spacing={0.5} p={0.5}>
        <Button color="inherit" size="small" onClick={onConfirm}>
          {control || "Confirm"}
        </Button>

        <Button color="inherit" size="small" onClick={onClose}>
          Cancel
        </Button>
      </Stack>
    ) : type === "confirm" ? (
      <Button color="inherit" size="small" onClick={onConfirm}>
        {control || "OK"}
      </Button>
    ) : null;

  const alertContent = (
    <Alert
      onClose={onClose}
      severity={severity}
      action={action}
      sx={{
        width: "95% !important",
        padding:"0px 5px !important",
        display: "flex",
        flexDirection:"column",
        alignItems: "flex-start !important",
        justifyContent:"start !important",
        border: "1px solid",

        fontWeight: 400,

        boxShadow: "0 2px 7px rgba(0, 0, 0, 0.18)",
      }}
    >
      {message}
    </Alert>
  );

  /*
   * Consultation-room mode:
   *
   * The parent decides where this
   * component appears.
   */
  if (mode === "overlay") {
    return alertContent;
  }

  /*
   * Existing/default behavior.
   */
  return (
    <Snackbar
      open
      anchorOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
      autoHideDuration={type === "alert" ? 3000 : undefined}
      onClose={(event, reason) => {
        if (reason === "clickaway") {
          return;
        }

        onClose?.();
      }}
    >
      {alertContent}
    </Snackbar>
  );
};

export default AlertBox;
